import * as FaqStyles from "./Faq.module.css"

import React, { useState } from "react"
import { RichText, types } from "react-bricks"

const Faq: types.Brick = () => {
    const [isCollapsed, setIsCollapsed] = useState(true)

    return (
        <div className={FaqStyles.wrapper}>
            <button
                onClick={() => setIsCollapsed(isCollapsed => !isCollapsed)}
                className={`${FaqStyles.block} ${isCollapsed ? FaqStyles.isCollapsed : ""}`}
            >
                <i className="lavita-icon">a</i>
                <RichText propName="textVisible" />
            </button>
            <div className={FaqStyles.content}>
                <div className={FaqStyles.inner}>
                    <div>
                        <RichText propName="textHidden" />
                    </div>
                </div>
            </div>
        </div>
    )
}

Faq.schema = {
    name: "FAQ",
    label: "FAQ",
}

export default Faq
